export default "__VITE_ASSET__de448c0b__"